'use client';

import { PbResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: PbResult;
  translations: ToolsTranslations['pb'];
  marketPricePerShare: number;
  bookValuePerShare: number;
  currency: string;
}

export default function ResultsDisplay({ result, translations, marketPricePerShare, bookValuePerShare, currency }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.pbRatio !== null ? `${result.pbRatio.toFixed(2)}${translations.ratioSuffix}` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>
      
      {/* Additional Information Box */}
      {result.isValid && result.pbRatio !== null && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-3"><b>{translations.additionalInfo.title}</b></p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <p className="text-gray-600">{translations.additionalInfo.marketPricePerShare}:</p>
              <p className="font-semibold text-gray-800">{marketPricePerShare.toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}</p>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.bookValuePerShare}:</span>
              <span className="font-semibold text-gray-800">
                {bookValuePerShare.toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.interpretation}:</span>
              <span className="font-semibold text-gray-800">
                {result.pbRatio < 1 ? translations.additionalInfo.undervalued : 
                 result.pbRatio < 3 ? translations.additionalInfo.fairValue : 
                 translations.additionalInfo.overvalued}
              </span>
            </div>
          </div>
        </div>
      )}
      
      <p className="text-xs text-gray-500">{translations.formulaNote}</p>
    </div>
  );
}
